import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { IProductItem } from "../../models/product";

interface FeatureGalleryGridProps<T> {
    title: string;
    items: T[];
    isReloading?: boolean;
    loadAction?: (id?:string) => Promise<void>;
    setReloadAction?: (state: boolean) => void;
    renderItem: (item: T) => JSX.Element;
}

export const FeatureGalleryGrid = observer(function FeatureGalleryGrid<T extends IProductItem>({ 
    title, items, isReloading, loadAction, setReloadAction, renderItem 
}: FeatureGalleryGridProps<T>) {
    // Shared loading logic
    useEffect(() => {
        if (typeof loadAction === 'function' && setReloadAction && (isReloading || items.length === 0)) {
            loadAction().then(() => setReloadAction(false));
        }
    }, [isReloading, items.length, loadAction, setReloadAction]);

    return (
       <section data-bs-version="5.1" className="pricing02 healthm5 cid-uAV5l3XCdZ" id="pricing02-k">
            <div className="position-relative">
                <div className="mbr-section-head">
                    <h4 className="mbr-section-title mbr-fonts-style align-center mb-0 display-2" style={{marginTop: '110px', paddingBottom: '20px'}}>
                        <strong>{title ? title : "Curated Luxury & Fashion Essentials"}</strong>
                    </h4>
                </div>
            </div>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="items-wrapper">
                            {items.map((item) => renderItem(item))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
});